<template>
  <div>
    <el-row>
      <el-col>
        <h1>My Approvals</h1>
        <el-select placeholder="Change Status" v-model="status">
          <el-option :key="1" label="Still Required" value="1"></el-option>
          <el-option-group label="Given" :key="2">
            <el-option :key="2" label="Awaiting Other Approvals" value="2"></el-option>
            <el-option :key="3" label="Fully Approved" value="3"></el-option>
            <el-option :key="4" label="Withdrawn" value="4"></el-option>
            <el-option :key="5" label="Cancelled" value="5"></el-option>
            <el-option :key="6" label="Denied" value="6"></el-option>
            <el-option :key="7" label="Denied with Conditions" value="7"></el-option>
            <el-option :key="8" label="Complete" value="8"></el-option>
            <el-option :key="9" label="All" value="0"></el-option>
          </el-option-group>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
      <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
      </el-alert>
      </el-col>
    </el-row>
    <pea-table
      :tableData="tableData"
      :page="page"
      :pageSize="pageSize"
      :resultTotal="resultTotal"
      :status="status"
      :tableLoading="tableLoading"
      :selectRow="selectRow"
      :currentChange="getPeas"
    >
    </pea-table>
  </div>
</template>

<script>
import router from '@/router'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    statusId: 0
  },
  data () {
    return {
      alertType: '',
      alertTitle: '',
      callInfo: '',
      resultTotal: 0,
      tableData: null,
      page: 1,
      pageSize: 5,
      status: this.statusId,
      tableLoading: true
    }
  },
  watch: {
    status: function () {
      router.push('/my-approvals/' + this.status)
    }
  },
  methods: {
    getPeas: function () {
      this.tableLoading = true
      var call = '/getMyApprovals/' + this.status + '?page=' + this.page + '&pageSize=' + this.pageSize
      this.$axios.get(call).then(response => {
        this.tableData = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
        helperMethods.showNotification(this, 'Error returning PEAs', reject.body, 'error', 30000, '')
      })
    },
    selectRow: function (row) {
      router.push('/editPea/' + row.id)
    }
  },
  mounted: function () {
    this.getPeas()
  },
  created: function () {
    this.$on('page', function (value) {
      this.page = value
    })
    this.$on('pageSize', function (value) {
      this.pageSize = value
    })
    this.$on('resultTotal', function (value) {
      this.resultTotal = value
    })
  }
}
</script>

<style scoped>

  h1 {
    float: left;
    margin-right: 30px;
  }

  .el-select {
    width: auto;
    position: relative;
    top: 3px;
  }

  ul {
    padding: 0;
    margin: 0;
    margin-left: 15px;
  }

</style>
